import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DoctorServiceService } from '../api-services/doctor-service.service';
import { AuthService } from '../api-services/Auth/auth.service';
import browserUser from '../..//assets/getUserDetails/getUserDetailsFromBrowser';

import { } from 'googlemaps';
/**
 * This Component is maintain register doctor list and their specialist ,address location.
 * Any user can search health issue related doctor and take request appointment that doctor.
 */
@Component({
  selector: 'app-talktodoctor',
  templateUrl: './talktodoctor.component.html',
  styleUrls: ['./talktodoctor.component.css']
})
export class TalktodoctorComponent implements OnInit {
  countryData :any= browserUser();
  browserCountryId:any;
  userCountryId:any;
  getCityNames_$: any;
  searchInfo: any;
  cityName: any;
  searchForm = new FormGroup({
    select_City: new FormControl('All', Validators.required),
    select_userRequired: new FormControl('', Validators.required)
  });
  data: any
  isLoading: boolean;
  keyword: any = 'lable';
  getDoctorInfo: any;
  loader: boolean;
  sendReq: any;
  paginationObj: any;
  gender: any;
  getToken: any;
  todayDate = new Date();
  isToggle: boolean;
  typeMode: any;
  p: number = 1;
  fileName: any;
  startAt: Date;
  endAt: Date;
  states_list: any;
  stateId = "";
  countryId= "";
  cities_list: any;
  countries_list: any
  constructor(public doctorService: TalkToDoctorService, private activeRouter: ActivatedRoute, private doctor_service: DoctorServiceService,
    public fb: FormBuilder, public router: Router, private auth: AuthService) {
    this.paginationObj = {
      currentPage: 1,
    };
  }

  ngOnInit() {

    let reqParam = this.activeRouter.snapshot.queryParams['subCat']
    if (reqParam != undefined) {
      let obj = {
        type: '',
        lable: reqParam
      };
      this.searchForm.get('select_userRequired').patchValue(obj)
    };
    this.doctor_service.getCountry().subscribe((data: any) =>{
       this.countries_list = data;
       //let countryCode = this.countryData.country[2];
       let countryCode;
       if(this.countryData.country[2]){
          countryCode = this.countryData.country[2];
       }else {countryCode = "USA";}
       if(this.countries_list){this.filterData(this.countries_list,countryCode)}
    });
    
  
    // this.auth.getCountryId().subscribe(res => {console.log("resCon",res)
    //   if (res) {
    //     this.stateId = "";
    //     this.searchForm.get('select_City').patchValue('All')
    //     this.countryId = +res;
    //     sessionStorage.setItem('countryId', JSON.stringify(+res));
    //     this.getState(this.countryId);
    //   } else {
    //     this.countryId = JSON.parse(sessionStorage.getItem('countryId'));
    //     this.getState(this.countryId);
    //   }
    // });

    
    
    

    this.getToken = JSON.parse(sessionStorage.getItem('userInfo'));
   
    this.sendReq = {
      number: this.p - 1,
      size: 5
    }
    this.doctorService.getGender().subscribe(gender$ => {
      this.gender = gender$;
    });
    this.getSearch();
  };

 /**
  * This method to take user searching value and display related information on search box
  * @param event This event parameter is access user input value
  */

  getSearchInfo(event: any) {
    if (event.trim()) {
      this.isLoading = true
      this.doctorService.getSearch(event).subscribe(data => {
        if (data) {
          this.data = data
          this.isLoading = false;
        }
      })
    } else {
      this.data = [];
    }
  };
  searchCleared() {
    this.data = [];
    this.sendReq.searchKeyword = "";
    this.searchForm.get('select_userRequired').patchValue('');
    // this.router.navigate(['/book-on-appointment'], { skipLocationChange: false })
    this.getSearch();
  };
 
  /**
   * This method to show doctors list based
   * on user selecting query
   */
  async getSearch() {
    this.loader = false;
    const type = this.searchForm.get('select_userRequired').value.type;
    let userSelected;
    if (type == 'Symptom' || type == 'Sub Speciality' || type == 'Speciality') {
      userSelected = this.searchForm.get('select_userRequired').value.Speciality
    } else {
      userSelected = this.searchForm.get('select_userRequired').value.lable == undefined ? "" : this.searchForm.get('select_userRequired').value.lable;
    }
    this.sendReq.city = this.searchForm.get('select_City').value
    this.sendReq.searchKeyword = userSelected;

    this.doctorService.getDoctorList(this.sendReq).subscribe(data => {
      this.getDoctorInfo = data;
      this.loader = true
    },
      err => {

      })
  };
  /**
   * This method take user selecting page number and display
   * doctor list 
   * @param pageNum This parameter is refer page number
   */
  getPagination(pageNum: any) {
    this.sendReq.number = pageNum - 1;
    this.getSearch();
  };



  getState(CountryId: any) {
    this.searchForm.get('select_City').patchValue('All')
    this.stateId = "";
    this.cities_list = []
    // this.stateId =CountryId
    this.doctor_service.getState(CountryId).subscribe(data => {
      this.states_list = data
    });
  }
  getCity(StateId: any) {
    this.doctor_service.getCity(StateId).subscribe(data => this.cities_list = data);
  }







  // geo location functionality added but not test If using future implement according to application scenrio

  // x=document.getElementById("demo");
  //  getLocation(){
  //     if (navigator.geolocation){
  //         navigator.geolocation.getCurrentPosition(this.showPosition,this.showError);
  //     }
  //     else{
  //         this.x.innerHTML="Geolocation is not supported by this browser.";
  //     }
  // }

  //  showPosition(position){
  //   let geocoder = new google.maps.Geocoder();
  //   let  lat=position.coords.latitude;
  //   let  lon=position.coords.longitude;
  //   //  this.displayLocation(lat,lon);
  //   var latlng = new google.maps.LatLng(lat, lon);
  //   geocoder.geocode(
  //     {location: latlng}, 
  //     (results, status) =>{
  //         if (status == google.maps.GeocoderStatus.OK) {
  //             if (results[0]) {
  //                 var add= results[0].formatted_address ;
  //                 var  value=add.split(",");

  //               let  count=value.length;
  //               let  country=value[count-1];
  //                let state=value[count-2];
  //               let  city=value[count-3];
  //                 this.x.innerHTML = "city name is: " + city;
  //             }
  //             else  {
  //                 this.x.innerHTML = "address not found";
  //             }
  //         }
  //         else {
  //           console.log(status);

  //             this.x.innerHTML = "Geocoder failed due to: " + status;
  //         }
  //     }
  // );
  // }

  // showError(error){
  //     switch(error.code){
  //         case error.PERMISSION_DENIED:
  //             this.x.innerHTML="User denied the request for Geolocation."
  //         break;
  //         case error.POSITION_UNAVAILABLE:
  //             this.x.innerHTML="Location information is unavailable."
  //         break;
  //         case error.TIMEOUT:
  //             this.x.innerHTML="The request to get user location timed out."
  //         break;
  //         case error.UNKNOWN_ERROR:
  //             this.x.innerHTML="An unknown error occurred."
  //         break;
  //     }
  // }

  //  displayLocation(latitude,longitude){
  //     var geocoder;
  //     geocoder = new google.maps.Geocoder();
  //     var latlng = new google.maps.LatLng(latitude, longitude);

  //     geocoder.geocode(
  //         {'latLng': latlng}, 
  //         (results, status) =>{
  //             if (status == google.maps.GeocoderStatus.OK) {
  //                 if (results[0]) {
  //                     var add= results[0].formatted_address ;
  //                     var  value=add.split(",");

  //                   let  count=value.length;
  //                   let  country=value[count-1];
  //                    let state=value[count-2];
  //                   let  city=value[count-3];
  //                     this.x.innerHTML = "city name is: " + city;
  //                 }
  //                 else  {
  //                     this.x.innerHTML = "address not found";
  //                 }
  //             }
  //             else {
  //                 this.x.innerHTML = "Geocoder failed due to: " + status;
  //             }
  //         }
  //     );
  // }

filterData(countries,countryCode) {
  let defaultCo=countries.filter(country=>{
    //console.log("object",country,country['countryCode'],countryCode);
    return country['countryCode3'] == countryCode;
  });
 this.userCountryId=defaultCo[0].countryId;
 sessionStorage.setItem('countryId', JSON.stringify(this.userCountryId));
 this.setCountryId();
}

setCountryId(){
  if(this.userCountryId){
    this.countryId = this.userCountryId;
    this.getState(this.countryId);
    //this.ngOnInit();
  }
}





}
